import { FC } from 'react';

import TabbedSwitcherV1 from 'components/TabbedSwitcher/TabbedSwitcherV1';
import TabbedSwitcherV2 from 'components/TabbedSwitcher/TabbedSwitcherV2';

type TabbedSwitcherProps = {
  type?: string;
};

const TabbedSwitched: FC<TabbedSwitcherProps> = ({ type, ...props }) => {
  switch (type) {
    case 'V2':
      return <TabbedSwitcherV2 {...props} />;
    default:
      return <TabbedSwitcherV1 {...props} />;
  }
};

export default TabbedSwitched;
